import AxiosHelper from 'services/AxiosHelper';

/**
 * Setup function for the newsletter sign up submission.
 *
 * @export
 */
export default function setupNewsletter() {
	const spanNewsletterSuccess = document.getElementById('spanNewsletterSuccess');
	const spanNewsletterFailure = document.getElementById('spanNewsletterFailure');
	const btnNewsletterSignup = document.getElementById('btnNewsletterSignup');
	const newsletterForm = document.getElementById('newsletterForm');

	btnNewsletterSignup?.addEventListener('click', () => {
		try {
			if (spanNewsletterFailure && spanNewsletterSuccess && newsletterForm) {
				spanNewsletterSuccess.style.display = 'none';
				spanNewsletterSuccess.style.opacity = '0';
				spanNewsletterFailure.style.display = 'none';
				spanNewsletterFailure.style.opacity = '0';
				newsletterForm.style.display = 'block';
				newsletterForm.style.opacity = '1';
			}

			const txtEmail = document.getElementById('txtEmail') as HTMLInputElement;

			const emailValue = txtEmail?.value;

			if (emailValue) {
				AxiosHelper.post('/ajax/newsletter-signup', {
					Email: emailValue,
				})
					.then((response) => {
						if (response.status === 200) {
							txtEmail.value = '';
							if (spanNewsletterSuccess && newsletterForm) {
								spanNewsletterSuccess.style.display = 'block';
								spanNewsletterSuccess.style.opacity = '1';
								newsletterForm.style.display = 'none';
								newsletterForm.style.opacity = '0';
							}
						} else {
							if (spanNewsletterFailure) {
								spanNewsletterFailure.style.display = 'block';
								spanNewsletterFailure.style.opacity = '1';
							}
						}
					})
					.catch((error) => {
						console.log(error);
						if (spanNewsletterFailure) {
							spanNewsletterFailure.style.display = 'block';
							spanNewsletterFailure.style.opacity = '1';
						}
					});
			}
		} catch (error) {
			console.error('Unable to post newsletter sign up:', error);
		}
	});
}
